import { Controller, useFormContext } from "react-hook-form";
import { Switch } from "../shadcn/switch";
import {
  ConfigToggleGroup,
  ConfigToggleGroupItem,
} from "@/types/api/spotflow/spotflow-config";
import { getIcon } from "@/utils/assistants";

interface ToggleGroupFieldProps {
  name: string;
  display: ConfigToggleGroup;
  isDisabled?: boolean;
}

function ItemIcon({ item }: { item: ConfigToggleGroupItem }) {
  if (item.image_url) {
    return (
      <div className="flex p-1.5 rounded-md justify-center items-center shrink-0 bg-muted/50">
        <img
          src={item.image_url}
          alt={item.label}
          className="w-4 h-4 object-contain"
        />
      </div>
    );
  }
  if (item.icon) {
    return (
      <div
        className="flex p-1.5 rounded-md justify-center items-center shrink-0"
        style={{
          backgroundColor: item.bg_color || "#eff6ff",
          color: item.icon_color || "#3b82f6",
        }}
      >
        {getIcon(item.icon)}
      </div>
    );
  }
  return null;
}

export const ToggleGroupField = ({
  name,
  display,
  isDisabled,
}: ToggleGroupFieldProps) => {
  const { control } = useFormContext();

  return (
    <div className="flex flex-col gap-2">
      {(display.title || display.description) && (
        <div>
          {display.title && (
            <p className="text-sm font-medium text-foreground leading-none">
              {display.title}
            </p>
          )}
          {display.description && (
            <p className="text-xs text-muted-foreground mt-1">
              {display.description}
            </p>
          )}
        </div>
      )}
      {(display.items ?? []).map((item) => (
        <Controller
          key={item.key}
          name={`${name}.${item.key}`}
          control={control}
          defaultValue={item.default ?? true}
          render={({ field }) => (
            <div className="border border-border rounded-md w-full overflow-hidden">
              <div className="flex items-center justify-between gap-2 px-2 py-1.5">
                <div className="flex items-center gap-2 flex-1 min-w-0">
                  <ItemIcon item={item} />
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-medium truncate">{item.label}</p>
                    {item.description && (
                      <p className="text-xs text-muted-foreground truncate">
                        {item.description}
                      </p>
                    )}
                  </div>
                </div>
                <Switch
                  checked={field.value}
                  onCheckedChange={field.onChange}
                  disabled={isDisabled}
                  className="shrink-0"
                />
              </div>
            </div>
          )}
        />
      ))}
    </div>
  );
};
